export class Cache {
    public static chartViewBox = null as unknown as { x: number, y: number, width: number, height: number };
}
